import Layout from 'components/Layout';
import AppShell from 'components/Layout/AppShell';

const Billing = () => {
  return (
    <Layout
      headerMenu={false}
      onBack
      bottomMenu
    >
      <AppShell variant='full' padded={false}>
        <iframe
          className='embed-page'
          title='Facturación Montepio Luz Savinon'
          src='https://facturacion.montepio.org.mx'
        />
      </AppShell>
    </Layout>
  );
};

export default Billing;
